import React from 'react';
import './CustomerReviews.css';

const reviews = [
  {
    logo: '/logos/company1.webp',
    quote: "The team was very easy to work with and very communicative.",
    feedback: "Priya Krishnan\nHead of Strategic Initiatives, Ecolibrium",
  },
  {
    logo: '/logos/company2.webp',
    quote: "Great team and service",
    feedback: "Marie-Laure C\nExecutive Sponsor, AppTweak",
  },
  {
    logo: '/logos/company3.webp',
    quote: "Productive and efficient outcomes in dedicated team of professionals.",
    feedback: "Dave L.\nCTO, TrustPortal",
  },
  {
    logo: '/logos/company4.webp',
    quote: "They were very flexible and adapted to our means of communications.",
    feedback: "Maria Josefa Perez Barral\nIT Project Assistant, Eurofound",
  },
  {
    logo: '/logos/company5.webp',
    quote: "Their framework is super unique and something I haven't seen before",
    feedback: "Mathias Storm Mouritsen\nHead of Product, Confinze ApS",
  }
];

const CustomerReviews = () => {
  return (
    <section className="customer-reviews-section">
      <div className="customer-wrapper">
        <div className="reviews-left">
          <h2>WHAT OUR CLIENTS SAY</h2>
        </div>

        <div className="reviews-right">
          <div className="reviews-scroll">
            {reviews.map((review, i) => (
              <div key={i} className="review-card">
                <div className="review-top">
                  <img src={review.logo} alt="Company logo" />
                  <div className="stars">5.0 ★★★★★</div>
                </div>
                <blockquote>{review.quote}</blockquote>
                <p>{review.feedback}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerReviews;